module.exports = __webpack_public_path__ + "static/developers-3bec7c71c4cd8ee787da7f352401ca17.jpg";